import type { FC } from 'react';
import { RotateCcw, Search } from 'lucide-react';
import { IpcButton } from './IpcButton';

type Props = {
  onReset: () => void;
  onSubmit: () => void;
};

export const IpcFilterActions: FC<Props> = ({ onReset, onSubmit }) => (
  <div className="ipc-filter-actions">
    <IpcButton variant="primary" htmlType="button" icon={<Search size={14} />} onClick={onSubmit}>
      查询
    </IpcButton>
    <IpcButton variant="secondary" htmlType="button" icon={<RotateCcw size={14} />} onClick={onReset}>
      重置
    </IpcButton>
  </div>
);
